/*
 * Author: Roger
 * File Created: Tuesday, 24-08-06 02:13 pm
 * Last Modified: Friday, 24-09-13 09:50 pm, by Dw
 */

import { styled, Typography } from '@mui/material';

export const StyledCardTitle = styled(Typography)(({ theme }) => ({
  fontSize: '40px',
  fontWeight: 700,
  lineHeight: '120%',
  [theme.breakpoints.only('xs')]: {
    fontSize: '24px',
  },
  [`& span`]: {
    fontSize: '0.7em',
    verticalAlign: 'super',
    lineHeight: 0,
  },
}));

export const Video = styled('video')(({ theme }) => ({
  width: '100%',
  height: '100vh',
  objectFit: 'cover',
  maxWidth: '814px',
  [theme.breakpoints.only('xs')]: {
    height: '300px',
  },
}));
